module.exports = __webpack_public_path__ + "assets/img/Type E (27).f5f293fd.jpg";